module.exports = __webpack_public_path__ + "img/img-flow-3-3.0243d8c5.png";